// The debrief room's words (lane B7 S14, CR-024 / CR-070 / CR-071): the room's name and the sentences it states about
// who must be in it and who has no vote. Every entry quotes his glossary (the D0 label suites discover this module).
// The room chain (Not Ready … Outcome Recorded / Blocked), Attendance roll, Missing attendee, No vote, Oversight,
// Reveal, Waived and Debrief readiness come from the design system; the summary's words from ../summary/labels.

import { defineLabels } from "@/mc/labels";

const REQUIRED = "\"Required: Recruiter, HM, HRBP, all Final Loop interviewers. Do not finalize with missing scorecards.\"";

export const ROOM_LABELS = /* @__PURE__ */ defineLabels({
  debriefRoom: { text: "Debrief room" 


},
});

export const ROOM_RULES = /* @__PURE__ */ defineLabels({
  requiredAttendees: { text: "Required: Recruiter, HM, HRBP, all Final Loop interviewers." },
  coordinatorNoVote: { text: "Coordinator schedules but has no vote." },
});
